<template>
    <div>
        <div class="rating-row" v-ripple @click="showSetStarsDialog">
            <v-icon v-for="i in 5" :key="i" size="18" :color="getStarColor(i)">
                {{ getStarIcon(i) }}
            </v-icon>
            <span class="rating-num">{{ coachStars }}</span>
        </div>

        <set-stars-dialog :coach="coach" ref="stars" @success="onSuccess" />
    </div>
</template>

<script>

import SetStarsDialog from '@/components/student/SetStarsDialog'
import { db } from '@/utils/Firebase'

export default {
    components: {
        SetStarsDialog,
    },
    data() {
        return {
            stars: '',
            coach: null,
        }
    },
    computed: {
        coachId(vm = this) {
            return vm.account?.studentSubscription?.coachId
        },
        coachStars(vm = this) {
            if (vm.coach?.rating) return Number(vm.coach.rating.stars).toFixed(1).replace('.0', '')
            return '0'
        },
        lastRate(vm = this) {
            return vm.account?.studentSubscription?.lastRate || null
        },
        canRate(vm = this) {
            if (!vm.lastRate) return true
            const last = this.$moment(vm.lastRate)
            const now = this.$moment()
            return !last.isSame(now, 'month')
        }
    },
    async mounted() {
        const vm = this
        await vm.loadCoachData()
    },
    methods: {
        getStarIcon(index) {
            const rating = parseFloat(this.coachStars)
            if (rating >= index) return 'mdi-star'
            if (rating >= index - 0.5) return 'mdi-star-half-full'
            return 'mdi-star-outline'
        },
        getStarColor(index) {
            const rating = parseFloat(this.coachStars)
            const filled = rating >= index || rating >= index - 0.5
            if (!filled) return 'outline2'
            return this.$vuetify.theme.dark ? 'primary' : 'accent'
        },
        showSetStarsDialog() {
            const vm = this
            if (!vm.canRate) return vm.toast(vm.$t('common.cant_rate_coach_this_month'), 'error')
            vm.$refs.stars.show()
        },
        async loadCoachData() {
            const vm = this
            if (!vm.coachId) return
            let coachRef = await db.collection('users').doc(vm.coachId).get()
            vm.coach = { ...coachRef.data(), id: coachRef.id }
        },
        onSuccess() {
            const vm = this
            vm.loadCoachData()
        }
    }
}
</script>

<style scoped>
.rating-row {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    background: var(--v-surface2-base);
    border: 1px solid var(--v-outline-base);
    border-radius: 20px;
    padding: 7px 16px;
    cursor: pointer;
    user-select: none;
    transition: background 0.15s;
}

.rating-row:hover {
    background: var(--v-outline-base);
}

.rating-num {
    font-size: 15px;
    font-weight: 700;
    color: var(--v-txtPrimary-base);
    margin-left: 2px;
}
</style>
